import React, { useState } from "react"
import { CardBody } from "reactstrap"
import toast from "react-hot-toast"

import { Modal } from "components/Modal"
import { Button } from "components/Button"

import { UseInventory } from "api/api.service"
import { useProductionScheduleContext } from "./ProductionScheduleContext"

const InventoriesUsedModal = ({
    isOpen,
    slot,
    handleCloseModal = () => {},
    onCancelClick = () => {},
}) => {
    const [isLoading, setIsLoading] = useState(false)

    const {
        timeLineHashMap,
        changeTimeLineData = () => {},
        stageHashMap,
    } = useProductionScheduleContext()

    const handleUseInventory = async () => {
        if (!slot?.id) return
        try {
            setIsLoading(true)

            const updatedMap = new Map(timeLineHashMap)
            const res = await UseInventory({
                timelineCellId: slot.id,
            })
            if (res.data) {
                for (const [stageKey, slots] of updatedMap.entries()) {
                    for (let currentSlot of slots) {
                        if (
                            currentSlot.slotId === slot.slotId &&
                            currentSlot.stageId === slot.stageId
                        ) {
                            currentSlot.inventoryUsed = true
                        }
                    }
                }
                changeTimeLineData(updatedMap)
                toast.success("Inventory marked as used")
                handleCloseModal()
            }
        } catch (err) {
            console.log("err", err)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            handleModalToggling={handleCloseModal}
            bodyClassName="p-0"
            customButton={true}
            hideModalHeaderSeparator={true}
            headerClasses="header-container"
            size="md"
            backdrop="static"
            modalTitle={"Mark Inventory as Used"}
        >
            <div className="d-flex flex-column align-items-center  mb-4 mt-4">
                <CardBody>
                    <h5 className="modal-label">
                        {`Are you sure, you want to mark this Inventory as used?`}
                    </h5>
                </CardBody>
                <div className="d-flex justify-content-between mt-5 vendor-modal-btn-container">
                    <Button
                        onClick={onCancelClick}
                        title="No"
                        className="vendor-modal-cancel-btn"
                    />

                    <Button
                        onClick={handleUseInventory}
                        title="Yes"
                        className="gt-btn-grad-primary vendor-modal-del-btn"
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </Modal>
    )
}

export default InventoriesUsedModal
